import { Injector, inject, Service } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CONSTANTS } from './shared/constants';

@Service()
export class TemplatePageTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private injector = inject(Injector);

  updateTitle(routerState: RouterStateSnapshot): void {
    const title = this.buildTitle(routerState);
    const contextName = this.getContextName(routerState.url.split('/')[1]);

    if (title !== undefined) {
      this.title.setTitle(`${title}${contextName ? ` - ${contextName}` : ''} - Foodback`);
    }
  }

  private getContextName(contextType: string): string | null {
    const translateService = this.injector.get(TranslateService);
    switch (contextType) {
      case CONSTANTS.CONTEXT.ACCOUNT:
        return translateService.instant('SHARED.SYSTEM.ACCOUNT');
      case CONSTANTS.CONTEXT.VENUE:
        return translateService.instant('SHARED.SYSTEM.VENUE');
      case CONSTANTS.CONTEXT.ADMIN:
        return translateService.instant('SHARED.SYSTEM.ADMIN');
      default:
        return null;
    }
  }
}
